import isSameCallback, { isDuplicateCallback } from '../_helpers/issamecallback.js';
// returns "_bind:KEY" events added by addDomListener which match given DOM event data
// selector, callback and context are compared only when they're given (or always if exact is true)
export default function findDomListeners(events, _ref, exact) {
  var eventName = _ref.eventName,
    selector = _ref.selector,
    callback = _ref.callback,
    context = _ref.context;
  if (exact === void 0) {
    exact = false;
  }
  var result = [];
  if (!events) {
    return result;
  }
  for (var i = 0; i < events.length; i++) {
    var domEvent = events[i].info.domEvent;
    if (domEvent && domEvent.eventName === eventName) {
      var selectorMatches = exact ? (domEvent.selector || null) === (selector || null) : !selector || selector === domEvent.selector;
      var callbackMatches = exact ? isDuplicateCallback(callback, domEvent.callback) : !callback || isSameCallback(callback, domEvent.callback);
      var contextMatches = exact ? domEvent.context === context : !context || context === domEvent.context;
      if (selectorMatches && callbackMatches && contextMatches) {
        result.push(events[i]);
      }
    }
  }
  return result;
}